<ds-input [label]="label | translate" [required]="required" [errorState]="errorState" [errorMessage]="errorMessage">
  <select ds-input-field class="mw-100" [disabled]="disabled" (change)="onRoleChange($event)">
    <option value="" disabled [selected]="normalizedSelection === ''">{{ placeholder | translate }}</option>
    @for (role of roleOptions; track role[$userRole._id]) {
      <option [value]="role[$userRole._id]" [selected]="role[$userRole._id] === normalizedSelection">
        {{ role[$userRole.translationKey] | translate }}
      </option>
    }
  </select>
</ds-input>
